import { AuthModel, IAuth } from "@core/models";

export class AuthDTO extends AuthModel {
  getBase64Credentials() {
    return `${btoa(`${this[IAuth.login]}:${this[IAuth.password]}`)}`;
  }

  postLoginCandidateData() {
    return {
      email: this[IAuth.login],
      password: this[IAuth.password],
    };
  }
}
